<template>
  <div class="prh-zj w-100" :class="{'p-0': type==='advLeader'}" v-if="isShow">
    <slot></slot>
    <van-swipe @change="onChange">
      <van-swipe-item class="pb-4" v-for="i in pages" :key="i">

        <div class="adv-zj-list mt-3 w-100 p-0" v-if="curPageList" :class="{'adv-leaders': type==='advLeader'}">
          <div class="ava-div" v-for="item in curPageList">
            <div @click="changeLeader(item.userId)" v-if="item.userInfo"
                 class="cursor-pointer zj-ava-info d-flex justify-content-center flex-column">
              <img class="bg-white" :src="getImgUrl(item)" alt="">
              <p class="text-white w-100 text-center mb-0 font-10 line-12 van-ellipsis">
                {{item.userInfo.name?item.userInfo.name:item.userInfo.nickname}}</p>
            </div>
          </div>
        </div>

      </van-swipe-item>
    </van-swipe>
  </div>

</template>

<script>
  import Vue from 'vue';
  import {Lazyload} from 'vant';
  import {Swipe, SwipeItem} from 'vant';
  import {mapState} from "vuex";

  Vue.use(Swipe);
  Vue.use(SwipeItem);

  Vue.use(Lazyload);

  export default {
    name: "teacherCourse",
    props: [
      'teacherList',
      'type'
    ],
    data() {
      return {
        pages: 1,
        index: 1,
        size: 4,
        curPageList: [],
        isShow: true,
        arrList: [],
        imgUrl: ''
      }
    },
    created() {
      this.arrList = this.teacherList;
    },
    computed: {
      ...mapState({
        uploadresUrl: state => state.uploadresUrl
      })
    },
    mounted() {
      if (this.arrList) {
        this.isShow = true;
        if (this.arrList.length > 4) {
          this.curPageList = this.arrList.slice(0, 4);
        } else {
          this.curPageList = this.arrList.slice(0);
        }
        this.pages = Math.ceil(this.arrList.length / this.size);
      } else {
        this.isShow = false;
      }
    },

    methods: {
      onChange(index) {
        this.curPageList = this.arrList.slice(index * this.size, index * this.size + 4);
        if (this.curPageList.length < 4) {
          for (let i = 0; i < 4; i++) {
            if (this.curPageList[i] && !this.curPageList[i].userInfo) {
              this.curPageList.splice(i, 1);
              this.curPageList.push({});
            } else if (!this.curPageList[i]) {
              this.curPageList.push({});
            }
          }
        }
      },
      changeLeader(id) {
        if (this.type === 'advLeader') {
          this.$emit('getUserId', id)
        } else {
          this.$router.push('/lecturer/' + id);
        }
      },
      getAvator: function (value) {
        let uploadresUrl = '//res.aqjsjx.com.cn/';
        let img = '/static/img/pro/userDefault.png';
        let avatarUrl = value;
        if (avatarUrl) {
          if (avatarUrl.indexOf('http') < 0) {
            img = uploadresUrl + avatarUrl;
          } else {
            img = avatarUrl;
          }
        }

        return img;
      },
      getImgUrl(item) {
        if (item.cover) {
          return this.getAvator(item.cover);
        } else {
          return this.getAvator(item.userInfo.avatarUrl);
        }
      }
    }
  }
</script>

<style>
  .prh-zj .van-swipe__indicators {
    bottom: 0;
  }

  .ava-div {
    width: 3.75rem;
    overflow: hidden;
  }

  .adv-leaders .ava-div + .ava-div {
    margin-left: .5rem;
  }

  .adv-leaders {
    justify-content: center !important;
  }
</style>
